export default __webpack_public_path__ + "static/media/servers2.39e757e9.svg";